module.exports = __webpack_public_path__ + "img/16581252_S.e5a87d9c.png";